import Request from "../types/Request";
import apiRequest from "../utils/api";

// Get all active Requests
// Throw error
export const getRequests = async (): Promise<Request[]> => {
  const response = await apiRequest('/api/requests');
  if (!response.ok) {
    throw new Error('Failed to fetch requests');
  }
  return await response.json();
};

// Get single request by id
// Throw error
export const getRequest = async (request_id: number): Promise<Request> => {
  const response = await apiRequest(`/api/requests/${request_id}`);
    if (!response.ok) {
      throw new Error('Failed to fetch request');
    }
  return await response.json();
};

// Create new request
// Throw error with data message
export const createRequest = async(params: {
  category: string;
  description: string;
  latitude: number;
  longitude: number;
  isApproximate: boolean;
  isTest: boolean;
}): Promise<Response> => {
  const {
    category,
    description,
    latitude,
    longitude,
    isApproximate,
    isTest
  } = params;

  const response = await apiRequest('/api/requests', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      category,
      description,
      latitude,
      longitude,
      isApproximate: isApproximate ? 1 : 0,
      isTest: isTest ? 1 : 0,
    }),
  });

  const data = await response.json();

  if (!response.ok) {
    throw new Error(data.message || 'Failed to create request');
  }

  return data;
};

// General function for updating request
export const updateRequest = async (url: string, body?: object): Promise<{ message: string }> => {
  const response = await apiRequest(url, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(body),
  });

  const data = await response.json();

  if (!response.ok) {
    throw new Error(data.message || 'Request update failed')
  }

  return data;
};

// Update request description
export const updateRequestDescription = async (request_id: number, description: string) => {
  return updateRequest(`/api/requests/${request_id}`, { description });
};

// Update request location
export const updateRequestLocation = async (
  request_id: number, 
  latitude: number,
  longitude: number,
  isApproximate: boolean
) => {
  return updateRequest(`/api/requests/${request_id}/location`, { latitude, longitude, isApproximate});
};

// Add respnder to request
export const addRequestResponder = async (request_id: number) => {
  return updateRequest(`/api/requests/${request_id}/addresponder`);
};

// Remove responder from request
export const removeRequestResponder = async (request_id: number, removedBy: string) => {
  return updateRequest(`/api/requests/${request_id}/removeresponder`, { removedBy });
};

// Set request status to ready
export const setRequestReady = async (request_id: number, gotHelp: boolean) => {
  const gotHelpAsBit = gotHelp ? 1 : 0;
  return updateRequest(`/api/requests/${request_id}/setready`, { gotHelp: gotHelpAsBit });
};

// Add view to request by id
// Catch error here (not critical for app's functionality)
export const addViewToRequest = async (request_id: number): Promise<void> => {
  try {
    const response = await apiRequest(`/api/requests/${request_id}/add-view`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
    });
    if (!response.ok) {
      console.error('Error adding a view to request.');
    }
  } catch (error) {
    console.error('Error adding a view to request:', error);
  }
};

// Delete request
// Throw error
export const deleteRequest = async (request_id: number): Promise<void> => {
  const response = await apiRequest(`/api/requests/${request_id}`, {
    method: 'DELETE'
  });

  if (!response.ok) {
    console.error('Error deleting request.');
  }
};

// SSE connection to server
/*export const createRequestUpdatesStream = (
  onMessage: (data: string) => void,
  onError?: (error: Event) => void
): EventSource => {
  const eventSource = new EventSource('/api/requests/updates');

  eventSource.onmessage = (event) => {
    onMessage(event.data);
  };

  eventSource.onerror = (error) => {
    console.error('SSE error:', error);
    onError?.(error);
  };

  return eventSource;
};*/